import {
	Box,
	Button,
	Container,
	Flex,
	FormControl,
	FormHelperText,
	FormLabel,
	Grid,
	GridItem,
	Heading,
	Input,
	Textarea,
	useToast,
} from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import LandingPageBanner from '../assets/images/landing-page-background.png';
import ScollableNavigation from '../components/Navigations/ScollableNavigation';
import * as Yup from 'yup';
import axios from 'axios';
import { API_ENDPOINT, API_ENV } from '@theark/react-common';

const ContactUs: React.FC = () => {
	const toast = useToast();
	const router = useRouter();
	const [formSubmitted, setFormSubmitted] = useState(false);

	const initialVal = {
		email: '',
		name: '',
		message: '',
	};
	const ContactSchema = Yup.object().shape({
		email: Yup.string().email().required('Email is required'),
		name: Yup.string().required('Name is required'),
		message: Yup.string().required('Message is required'),
	});

	return (
		<Container maxW="7xl">
			<Flex position="relative">
				<Flex
					w={'100%'}
					backgroundImage={LandingPageBanner.src}
					backgroundSize={'45%'}
					backgroundRepeat={'no-repeat'}
					backgroundPosition={'590px 0;'}
					display={{ base: 'block', md: 'flex' }}
				>
					<Box marginTop="60px" mr="10" width={{ base: '100%', md: '240px' }}>
						<Flex display={{ base: 'block', md: 'flex' }} marginBottom={5} pb={3} borderBottom="1px">
							<Box mr={3} mb={{ base: 3, md: 0 }}>
								<Button
									onClick={() => {
										router.back();
									}}
									w={8}
									h={8}
									borderRadius={5}
									bg={'gray.800'}
								>
									<MdKeyboardArrowLeft />
								</Button>
							</Box>
							<Box>
								<Heading fontSize="28" width="240px">
									Contact Us
								</Heading>
							</Box>
						</Flex>

						<ScollableNavigation pathName={router.route} items={[]} />
					</Box>
					<Formik
						enableReinitialize={true}
						initialValues={initialVal}
						onSubmit={async (values: unknown) => {
							try {
								await axios(`${API_ENDPOINT}/${API_ENV}/contact`, {
									method: 'POST',
									headers: {
										'Content-Type': 'application/json',
									},
									data: JSON.stringify(values),
								});
								toast({
									title: 'Success!',
									description: 'Form Successfully.',
									status: 'success',
									duration: 2000,
									isClosable: true,
								});
								setFormSubmitted(true);
							} catch (error) {
								toast({
									title: 'Error!',
									description: 'Form submission failed.',
									status: 'error',
									duration: 2000,
									isClosable: true,
								});
								setFormSubmitted(false);
							}
						}}
						validationSchema={ContactSchema}
					>
						{({ values, handleChange, handleSubmit, handleBlur, isSubmitting }) => (
							<Box className="itemBg" rounded="md" width={{ base: '100%', md: '70%' }} mt="8" p="8">
								<Heading mb={2} fontSize="28">
									Contact Us
								</Heading>
								<Form onSubmit={handleSubmit}>
									<Grid templateColumns="repeat(1, 1fr)" gap={6}>
										<GridItem w="100%">
											<FormControl isRequired>
												<FormLabel>Name</FormLabel>
												<Input
													placeholder="Name"
													onChange={handleChange}
													value={values.name || ''}
													id="name"
													name="name"
													variant="form-input"
													type="text"
													size="md"
													onBlur={handleBlur}
												/>
											</FormControl>
										</GridItem>
										<GridItem w="100%">
											<FormControl isRequired>
												<FormLabel>Email</FormLabel>
												<Input
													placeholder="Email"
													onChange={handleChange}
													value={values.email || ''}
													id="email"
													name="email"
													variant="form-input"
													type="email"
													size="md"
												/>
											</FormControl>
										</GridItem>
										<GridItem w="100%">
											<FormControl isRequired>
												<FormLabel>Message</FormLabel>
												<FormHelperText mb={2}>
													Please provide a detailed description so the team can help with your query.
												</FormHelperText>
												<Textarea
													placeholder="Provide a detailed description of your item."
													onChange={handleChange}
													value={values.message}
													id="message"
													name="message"
													variant="form-input"
													rows={6}
												/>
											</FormControl>
										</GridItem>
										<GridItem w="100%">
											<Button
												isLoading={isSubmitting}
												disabled={formSubmitted}
												loadingText="Submitting"
												type="submit"
												float="right"
												className="buttonGradient"
												w={150}
												h={39}
											>
												Submit
											</Button>
										</GridItem>
									</Grid>
								</Form>
							</Box>
						)}
					</Formik>
				</Flex>
			</Flex>
		</Container>
	);
};

export default ContactUs;
